/**
 * @license lucide-react v0.570.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const __iconNode = [
  ["path", { d: "M21 11.693V5", key: "175m1t" }],
  ["path", { d: "m22 22-1.875-1.875", key: "13zax7" }],
  ["path", { d: "M3 12a9 3 0 0 0 8.697 2.998", key: "151u9p" }],
  ["path", { d: "M3 5v14a9 3 0 0 0 9.28 2.999", key: "q2rs2p" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }]
];
const DatabaseSearch = createLucideIcon("database-search", __iconNode);

export { __iconNode, DatabaseSearch as default };
//# sourceMappingURL=database-search.js.map
